import React from "react";
import { RootMenu } from "main/menu/RootMenu";
import { useMenuUserItems } from "main/menu/_hooks/useMenuUserItems";

export function MenuUser() {
    const menuUserItems = useMenuUserItems();

    return (
        <>
            {menuUserItems.map((item, index) => (
                <RootMenu key={index} withLang={true} menu={item} />
            ))}
        </>
    );
}
